import { Injectable, OnInit, EventEmitter, Component, AfterViewInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';

import { LocalizationService } from '@services/localization.service';
import { TranslatePipe } from '@pipes/translate.pipe';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'register-component',
  templateUrl: '../sharedTemplates/register-success.component.html',
})
export class RegisterSuccessComponent implements AfterViewInit {
  constructor(private _LocalizationService: LocalizationService, private _ApiService: ApiService) {}

  ngAfterViewInit() {
    try {
      let scrollcord;
      scrollcord = document.getElementById('ScrollingTop');
      setTimeout(() => {
        if (scrollcord != null) {
          scrollcord.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
      }, 500);
    } catch (e) {
      console.warn('İtem not found.');
    }
  }
}
